const days = require("dayjs");

module.exports = {
    formatDate: (item, format) => {
        return days(item).format(format);
    },
};